// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, sans-serif'
  },
  palette: {
    secondary: {
      main: '#ecf0f1',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2B2B2B',
          color: '#fff',
        },
      },
    },
  },
});

export default theme;
